import React from 'react';
import getCroppingQueryParams from '../util/getCroppingQueryParams';
import cx from 'classnames';
import Picture from './Picture.jsx';

export default class PictureWithPreload extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }

  onLoad() {
    this.setState({loaded: true});
  }

  render() {
    const { src, className } = this.props;
    const blurredImg = src + getCroppingQueryParams('preload');

    return (
      <div className="preload-img">
        { src && <img className="blurred-img" src={blurredImg} /> }
        <Picture {...this.props} className={cx(className, 'actual-img', {loaded: this.state.loaded})} onLoad={() => this.onLoad()} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/component/PictureWithPreload.jsx